export function getHexFromColor(color: string): string {
  switch (color) {
    case 'blue': return '#2e4fcb'
    case 'red': return '#dd0000'
    case 'green': return '#38a169'
    case 'orange': return '#f73e01'
    case 'purple': return '#8f00c7'
    case 'yellow': return '#e2e700'
    default: return '#000000'
  }
} 